import env from 'VirtualEnv'

export const URL = env.API_URL || 'http://localhost:3001'
